import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_cfar_on_sr_fd",
  stages: {
    main: 1,
    ddot: 2,
    mdot: 3,
    main_sr: 4,
    main_fd: 5,
    meta: 6,
    bf: 7,
    non_bf: 8,
    cfar_and_flex_badges: 9
  },
  goals: {
    action_click_with_cfar_badge_on_sr: 1
  },
  defaultStage: 1
});

const trackStages = (
  isMobile: boolean,
  isMetaUser: boolean,
  hasBrandedFare: boolean,
  isCfarAndFlexBadge: boolean,
  page: "flight_details" | "search_results"
) => {
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (isMetaUser) utils.stages.meta();
  hasBrandedFare ? utils.stages.bf() : utils.stages.non_bf();
  if (isCfarAndFlexBadge && page === "search_results") utils.stages.cfar_and_flex_badges();
  page === "flight_details" ? utils.stages.main_fd() : utils.stages.main_sr();
};

export default { trackStages, ...utils };
